// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { Tooltip } from '@mui/material';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export interface ClipboardProps {
  className?: string;
  text: string;
  icon?: React.ReactNode;
}

class Clipboard extends React.Component<ClipboardProps> {
  static defaultProps = {
    icon: <FileCopyOutlinedIcon style={{ fontSize: 15 }} />
  };

  readonly state = {
    showSuccessMsg: false,
  };

  private handleCopy = () => {
    this.setState(() => ({ showSuccessMsg: true }));

    setTimeout(() => {
      this.setState(() => ({ showSuccessMsg: false }));
    }, 1000);
  }

  render() {
    const { text, icon } = this.props;
    const classes = withStyles.getClasses(this.props);

    return (
      <Tooltip
        open={this.state.showSuccessMsg}
        title="Copied!"
        placement="right"
      >
        <span className={classes.root}>
          <CopyToClipboard
            text={text}
            onCopy={this.handleCopy}
          >
            {icon}
          </CopyToClipboard>
        </span>
      </Tooltip>
    );
  }
}

const ClipboardStyled = withStyles(
  Clipboard, 
  (theme, props) => ({
    "root": {
      display: 'flex',
      paddingLeft: theme.spacing(2),
      cursor: 'pointer',
    }
  })
);

export default ClipboardStyled;